interface AxiosErrorResponse {
  status?: number;
  data?: {
    statusCode?: number;
    message?: string;
    error?: string;
  };
}

interface AxiosError {
  response?: AxiosErrorResponse;
  message?: string;
}

interface MainModalConfig {
  title: string;
  body: string;
  iconType?: "error" | "success" | "warning" | "email" | "scanFace";
  isSuccess?: boolean;
  confirmHandler?: () => void;
  noHandler?: () => void;
  yesLabel?: string;
  noLabel?: string;
  dismiss?: boolean;
  customCloseMainModal?: () => void;
  noActionNeeded?: boolean;
}

type Dispatch = (action: any) => void;
type ActionCreator = () => { type: string; payload?: any };

export const isSubscriptionError = (error: any): boolean => {
  if (!error) return false;
  
  const axiosError = error as AxiosError;
  const status = axiosError.response?.status || axiosError.response?.data?.statusCode;
  const message = axiosError.response?.data?.message || '';
  const messageLower = message.toLowerCase();
  
  return (
    status === 403 &&
    (messageLower.includes('free trial') ||
     messageLower.includes('subscription') ||
     messageLower.includes('subsciption') ||
     messageLower.includes('expired') ||
     messageLower.includes('no activated'))
  );
};

export const handleSubscriptionError = (
  error: any,
  dispatch: Dispatch,
  openSuscriptionModal: ActionCreator,
  openMainModal?: ActionCreator,
  closeMainModal?: ActionCreator,
  customMessage: MainModalConfig | null = null
): boolean => {
  if (isSubscriptionError(error)) {
    if (openMainModal) {
      const defaultMessage: MainModalConfig = {
        title: "Suscripción requerida",
        body: "Para realizar esta acción necesitas una suscripción activa. Elige un plan para continuar.",
        iconType: "error",
        isSuccess: false,
        confirmHandler: () => {
          if (closeMainModal) {
            dispatch(closeMainModal());
          } else {
            dispatch({ type: 'CLOSE_MAIN_MODAL' });
          }
          setTimeout(() => {
            dispatch(openSuscriptionModal());
          }, 300);
        },
        noHandler: () => {
          if (closeMainModal) {
            dispatch(closeMainModal());
          } else {
            dispatch({ type: 'CLOSE_MAIN_MODAL' });
          }
        },
        yesLabel: "Ver planes",
        noLabel: "Cerrar"
      };

      const message = customMessage || defaultMessage;
      dispatch(openMainModal(message));
    } else {
      dispatch(openSuscriptionModal());
    }
    
    return true;
  }
  return false;
};




